/*
 * (c) copyright 2021 International Road Dynamics Inc. and related companies.
 * All rights reserved.
 * Copyright as an unpublished work.
 *
 * This file contains confidential information of International
 * Road Dynamics Inc. and related companies, and should be treated as proprietary
 * and confidential.
 *
 * The use, copying, disclosure or modification of the
 * programs and/or source code is prohibited unless
 * otherwise provided for in the license or confidentiality
 * agreements.
 *
 * Any copy must contain this copyright notice.
 */

import React from 'react'
import PropTypes from 'prop-types'

import {
  InfoWindow,
  Marker
} from '@react-google-maps/api'

import {
  ExternalUrlTypes,
  SiteTypes
} from '../../constants'
import {
  getIconDimensionBySize,
  getIconUrlByStatusAndType,
  getVwsUrlLabelSuffix,
  sortVwsUrls
} from '../../util/Helpers'

import './MapMarker.css'

function MapMarker (props) {
  function handleMarkerClick () {
    props.onClick(props.site.id)
  }

  const links = []

  // Get Acyclica URL if available
  props.site.externalUrls.filter((url) => url.type === ExternalUrlTypes.ACYCLICA)
    .forEach((url) => {
      links.push(
        <a
          key="AcyclicaLink"
          target="_blank"
          className="AcyclicaLink"
          href={url.url}
          rel="noreferrer"
        >
          Real-Time
        </a>
      )
    })

  // Get VWS URL(s) if available
  let vwsUrls = props.site.externalUrls.filter((url) => url.type === ExternalUrlTypes.VWS)
  if (vwsUrls.length > 0) {
    vwsUrls = sortVwsUrls(vwsUrls)
    vwsUrls.forEach((url) => {
      const direction = getVwsUrlLabelSuffix(url.parameters)
      let key = 'VwsLink'
      let label = 'VWS'
      if (direction) {
        key += `_${direction}`
        label += ` ${direction}`
      }

      links.push(
        <a
          key={key}
          target="_blank"
          rel="noreferrer"
          className="VwsLink"
          href={url.url}
        >
          {label}
        </a>
      )
    })
  }

  const { width, height } = getIconDimensionBySize(props.site.iconSize)

  const icon = {
    url: getIconUrlByStatusAndType(props.site.status, props.site.type),
    scaledSize: new window.google.maps.Size(width, height)
  }

  return (

    <Marker
      position={{
        lat: props.site.latitude,
        lng: props.site.longitude
      }}
      title={props.site.name}
      icon={icon}
      onClick={handleMarkerClick}
    >
      {props.isSelected &&
      <InfoWindow
        onCloseClick={props.onClose}
      >
        <div className="MapMarkerPopupContent">
          <h1>{props.site.name}</h1>

          <ul>
            <li key="address"><strong>Address:</strong> <span>{props.site.address}</span></li>
            <li key="island"><strong>Island:</strong> <span>{props.site.island}</span></li>
            <li key="latitude"><strong>Latitude:</strong> <span>{props.site.latitude}</span></li>
            <li key="longitude"><strong>Longitude:</strong> <span>{props.site.longitude}</span></li>
            <li key="type"><strong>Type:</strong> <span>{SiteTypes[props.site.type]}</span></li>
          </ul>

          {links.length > 0 &&
          <p className="MapMarkerPopupContentLinks">{links}</p>
          }
        </div>
      </InfoWindow>
      }
    </Marker>
  )
}

MapMarker.propTypes = {
  isSelected: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  site: PropTypes.object
}

MapMarker.defaultProps = {
  isSelected: false
}

export default MapMarker
